import { Switch } from "@chakra-ui/react";

export const ToggleSwitch = ({ label, value, onChange, w, disabled }) => {
  return (
    <Switch.Root
      disabled={disabled || false}
      checked={value ? true : false}
      onCheckedChange={(e) => onChange && onChange(e.checked)}
      colorPalette="cyan"
      w={w}
    >
      <Switch.HiddenInput />
      <Switch.Control>
        <Switch.Thumb />
      </Switch.Control>
      <Switch.Label>{label}</Switch.Label>
    </Switch.Root>
  );
};
